import React from 'react';
export function Differentiator() {
  return <section className="bg-white py-16 px-4 sm:px-6" data-id="element-73">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-74">
        <div className="text-5xl mb-4" data-id="element-75">🧠</div>

        <h2 className="font-archivo text-3xl sm:text-4xl md:text-5xl uppercase text-brand-black" data-id="element-76">
          Diseñado para familias reales
        </h2>

        <div className="bg-brand-yellow/20 p-6 rounded-xl border-2 border-brand-yellow max-w-2xl mx-auto" data-id="element-77">
          <p className="font-bold text-xl sm:text-2xl text-brand-black" data-id="element-78">
            👉 No son actividades imposibles ni "Pinterest irreales".
          </p>
        </div>

        <div className="space-y-6" data-id="element-79">
          <p className="text-xl font-bold text-gray-700" data-id="element-80">
            Todo está pensado para:
          </p>

          <div className="flex flex-wrap justify-center gap-4 max-w-xl mx-auto" data-id="element-81">
            {['poco tiempo', 'materiales simples', 'familias ocupadas', 'uso cotidiano'].map(item => <div key={item} className="bg-gray-100 px-6 py-3 rounded-full font-bold text-brand-black flex items-center gap-2 text-lg" data-id="element-82">
                <span className="text-brand-green" data-id="element-83">✔</span> {item}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}